import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { ConsultaJuc } from '../dto/consulta-juc.model';


@Component({
  selector: 'app-juc-ia',
  templateUrl: './juc-ia.component.html',
  styleUrls: ['./juc-ia.component.scss']
})

export class JucIaComponent implements OnInit {


  @ViewChild('form') public roleForm: NgForm;
  @ViewChild('fruitInput') fruitInput: ElementRef;
  //@ViewChild('autosize') autosize: CdkTextareaAutosize;
  validationFail = false;

  consultaJuc: ConsultaJuc = new ConsultaJuc();

  constructor(
    private router: Router,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
  ) { }

  ngOnInit() {
  }

  back() {
    this.router.navigate(['/codigos-promocion']);
  }

  async save() {
    if (this.validateForm()) {
      debugger
      if(this.consultaJuc.consulta.length == 0){
        this.snackService.error("Debe escribir una consulta")
        return 
      }

      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.saveItem(true);
    }

    return;
  }

  /*async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea modificar los precios' +'?')
    .then( res => {
      if (res) {
       this.saveItem(res);
      }
    });
  }*/

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
       // Update
      
        try {
          var response;
           await this.backendService.create("/notificaciones/ia-juc", this.consultaJuc).then((data)=>{
   
            this.consultaJuc.respuesta = (<any>data)._body;
            debugger
           });
          this.snackService.success('Código Agregado');
          //this.router.navigate(['/codigos-promocion']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
        
      }
    }


}



// WEBPACK FOOTER //
// ./src/app/juc/juc-ia/juc-ia.component.ts